import React, {useState, useEffect} from 'react'

import classes from './ActivityLives.module.css'
import { FaHeart, FaRegHeart } from 'react-icons/fa6';


import heart_full from "./heart_full.png"
import heart_empty from "./heart_empty.png"

const ActivityLives = ({lives, total}) => {

  return (
    <div className={classes.ActivityLives}>
      Essais restants

      <div className={classes.lives}>
        {new Array(total).fill("").map((_, index) => {
          if(index + 1 > lives) return <img src={heart_empty} />
          return <img src={heart_full} />
        })}
      </div>

    </div>
  );
};

export default ActivityLives;
